import React, { Component } from 'react';
import {  bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setCurrent, filterProj } from '../actions'
import { push } from 'react-router-redux'

class Nav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuExpanded: false,
      hover: false,
      bgColor: ''
    }
  }

  handleClick(filter) {
    this.props.filterProj(filter);
    filter === 'all' || filter === 'about' ? this.props.push('/' + filter) : this.props.push(`/${filter}`);
    this.setState({
      menuExpanded: false
    })
  }

  currentFilter() {
    if (this.props.pathname !== '/all') {
      var path = this.props.pathname;
      var filter = path.substring(1, path.length);
      var desc;
      if (filter === 'projects') {
        desc = ' // client work & completed projects';
      } else if (filter === 'experiments') {
        desc = ' // snippets, vignettes, & works in progress';
      }
      return (<span className="filter"><span className="mobile-only">#</span><strong>{filter}</strong><span className="desktop-only">{desc}</span></span>)
    }
  }

  handleHover(val) {
    if (window.outerWidth > 800) {
      var bgColor = val && window.scrollY > 70 ? 'rgba(255,255,255,1)':'';

      this.setState({
        menuExpanded: val,
        bgColor: bgColor
      })
    }
  }

  render() {
    return (
      <div>
        <div className="Nav desktop-only"
          onMouseOver={this.handleHover.bind(this, true)}
          onMouseLeave={this.handleHover.bind(this, false)}
          style={{backgroundColor: this.state.bgColor}}>
          <span className="mw-icon" >MW</span>
          <span className={this.state.menuExpanded ? "about-me menu-expand":"about-me menu-hide" }>
            <span className="link" onClick={this.handleClick.bind(this,'about')}>about</span>
            <strong>[ </strong>
            <span className="link" onClick={this.handleClick.bind(this,'all')}>all work</span>
            <span className="link" onClick={this.handleClick.bind(this,'projects')}>projects</span>
            <span className="link" onClick={this.handleClick.bind(this,'experiments')}>experiments</span>
            <strong> ]</strong>
          </span>
          {this.currentFilter()}
        </div>
        <div className="mobile-only">
          {this.currentFilter()}
          <div className="mobile-menu-toggle mobile-only" onClick={()=>{this.setState({menuExpanded: !this.state.menuExpanded});}}></div>
            <div className="mobile-menu-expand mobile-only" style={{ left: this.state.menuExpanded ? '0px':'100%'}}>
              <span style={{backgroundColor: '#F8F8F8'}} onClick={this.handleClick.bind(this,'about')}>about</span>
              <span style={{backgroundColor: '#F5F5F5'}} onClick={this.handleClick.bind(this,'all')}>all work</span>
              <span style={{backgroundColor: '#F0F0F0'}} onClick={this.handleClick.bind(this,'projects')}>projects</span>
              <span style={{backgroundColor: '#E8E8E8'}} onClick={this.handleClick.bind(this,'experiments')}>experiments</span>
              <div id="mobile-footer">
                © 2017 Melissa Wei
              </div>
            </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    current: state.current,
    projects: state.projects,
    styles: state.styles
  })
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setCurrent, filterProj, push
  }, dispatch)
}

const ConnectedNav = connect(mapStateToProps, mapDispatchToProps)(Nav)

export default ConnectedNav



// WEBPACK FOOTER //
// ./src/components/nav.js